/* eslint react/forbid-prop-types: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import VehicleTable from "./VehicleTable";
import Client from "../../../../Client";

class AllocateRunsheet extends Component {
  state = {
    fleets: [],
    vehicles: [],
    fleetId: ""
  };

  componentDidMount() {
    Client.getFleets().then(fleets => this.setState({ fleets }));
    // Client.getVehicles().then(vehicles => this.setState({ vehicles }));
  }

  assignVehicle = vehicle => {
    if (!vehicle) {
      this.closeAllocateRunsheet();
    }
    const { runsheet } = this.props;
    runsheet.vehicle = vehicle.id;
    this.props.allocateRunsheet(runsheet.id, runsheet).then(() => {
      this.props.updateVehicle(runsheet.id, vehicle);
      this.props.closeModal();
    });
  };

  removeAllocation = () => {
    const { runsheet } = this.props;
    runsheet.vehicle = -1;
    this.props.allocateRunsheet(runsheet.id, runsheet).then(() => {
      this.props.removeVehicle(runsheet.id);
      this.props.closeModal();
    });
  };

  closeAllocateRunsheet = () => {
    this.props.closeModal();
  };

  handleFleetChange = selectedOption => {
    if (selectedOption) {
      const fleetId = selectedOption.value;
      Client.getVehiclesInFleet(fleetId).then(vehicles =>
        this.setState({ fleetId, vehicles })
      );
    } else {
      this.setState({ fleetId: "", vehicles: [] });
    }
  };

  render() {
    const { runsheet } = this.props;
    const { fleetId, fleets, vehicles } = this.state;
    let vehicleId;
    if (runsheet.vehicle) {
      vehicleId = runsheet.vehicle.id;
    } else {
      vehicleId = 0;
    }

    return (
      <VehicleTable
        fleets={fleets}
        fleetId={fleetId}
        vehicles={vehicles}
        initialVehicleId={vehicleId}
        handleAssignVehicle={this.assignVehicle}
        removeAllocation={this.removeAllocation}
        closeAllocateRunsheet={this.closeAllocateRunsheet}
        handleFleetChange={this.handleFleetChange}
      />
    );
  }
}
AllocateRunsheet.propTypes = {
  runsheet: PropTypes.object.isRequired,
  allocateRunsheet: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  updateVehicle: PropTypes.func.isRequired,
  removeVehicle: PropTypes.func.isRequired
};

export default AllocateRunsheet;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/actions/AllocateRunsheet.js